<script setup lang="ts">
  import DocumentProgressBar from './DocumentProgressBar.vue';
  import type { FileStatus } from '@/features/Document';

  defineProps<{
    files: File[];
    getFileProgress: (file: File) => number;
    getFileStatus: (file: File) => FileStatus;
    filiais?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'imageDeleted', file: File): void;
  }>();
</script>

<template>
  <div class="mt-6 w-full border border-dashed rounded-xl border-gray-02 divide-y divide-gray-02">
    <div
      v-for="file in files"
      :key="file.name"
      class="p-4"
    >
      <DocumentProgressBar
        :get-file-progress="getFileProgress"
        :file="file"
        :get-file-status="getFileStatus"
        :filiais="filiais"
        @image-deleted="(file) => emit('imageDeleted', file)"
      />
    </div>
  </div>
</template>
